// ============================================================
// Central pricing source — the ONLY place prices are defined.
// Every section (Services, Comparison table, Maintenance) reads
// from here so the numbers can never drift out of sync.
// ============================================================
export const PRICES = {
  secureSystemAudit: 35000,
  excelToSoftware: 285000,
  aiWorkflows: 95000,
  securityCompliance: 25000,
  websiteDashboard: 100000,
};

// Localized "From <amount> DKK". Uses NON-BREAKING spaces so the spacing can
// never visually collapse under tight display tracking (fixes "From25,000DKK").
export const formatPrice = (key, lang = "en") => {
  const amount = PRICES[key];
  if (amount == null) return "";
  const isDa = lang === "da";
  const num = amount.toLocaleString(isDa ? "da-DK" : "en-US");
  return `${isDa ? "Fra" : "From"}\u00A0${num}\u00A0DKK`;
};

// ------------------------------------------------------------
// Monthly Service & Maintenance plans (recurring). Single source
// of truth for the ServiceMaintenanceSection — never hardcoded.
// ------------------------------------------------------------
export const MAINTENANCE_PRICES = {
  websiteCare: 4500,
  systemCare: 9500,
  missionCritical: 19000,
};

// Order maps the maintenance plan cards (by index) to a price key.
export const MAINTENANCE_KEYS = ["websiteCare", "systemCare", "missionCritical"];

// Localized monthly "From <amount> DKK/mo." / "Fra <amount> DKK/md." (nbsp-safe).
export const formatMonthlyPrice = (key, lang = "en") => {
  const amount = MAINTENANCE_PRICES[key];
  if (amount == null) return "";
  const isDa = lang === "da";
  const num = amount.toLocaleString(isDa ? "da-DK" : "en-US");
  return `${isDa ? "Fra" : "From"}\u00A0${num}\u00A0DKK${isDa ? "/md." : "/mo."}`;
};

// Public rule-of-thumb annual maintenance budget. Kept modest (15-30% of the
// initial build cost) and shown only as a small secondary note — never a hero number.
export const MAINTENANCE_BUDGET = {
  pctMin: 15,
  pctMax: 30,
};
